// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MZed","col":"styles_col__2AkRw"};